<div data-automation="cisco-dn-report-modal">
  <div class="row">
    <div class="col-md-12 dn-report-modal-content">
      <ziro-radio [fieldId]="'draftType'"></ziro-radio>
      <ziro-text [fieldId]="'jobName'"></ziro-text>
      <ziro-select [fieldId]="'existingBulkDraft'"></ziro-select>
      <ziro-select [fieldId]="'dialPlanGroup'"></ziro-select>
    </div>
  </div>
</div>

<ng-template #errorTemplate>
  <span [hidden]="!isSubmitted || (isSubmitted && isFormValid())">
    {{ 'tkey;validators.global.required.missing.error' | translate }}
  </span>
</ng-template>
